// Användarvillkor (#324) — structure ours, final wording the client's.
//
// The headings below are the ones a Swedish consumer-facing service is normally
// expected to cover, so Abdi's text has somewhere to land section by section
// rather than arriving as one undifferentiated block. Each placeholder paragraph
// says what belongs there.
import React from 'react';
import { LegalPage, LegalSection, LegalDraftNotice } from './LegalPage';

const TermsPage: React.FC = () => (
    <LegalPage
        title="Användarvillkor"
        intro="Villkoren för att använda Nexilink som arbetssökande eller arbetsgivare."
    >
        <LegalDraftNotice />

        <LegalSection heading="1. Om tjänsten">
            <p>
                Nexilink är en plattform för rekrytering, introduktion och kompetensutveckling inom
                välfärdssektorn. Här beskrivs vad tjänsten omfattar och vem som tillhandahåller den.
            </p>
        </LegalSection>

        <LegalSection heading="2. Konto och behörighet">
            <p>
                Villkor för att skapa konto: ålderskrav, korrekta uppgifter, ansvar för lösenord, och
                vad som gäller för konton som skapas åt dig av en arbetsgivare.
            </p>
        </LegalSection>

        <LegalSection heading="3. Så får tjänsten användas">
            <p>
                Vad som är tillåtet och otillåtet — exempelvis att lämna riktiga uppgifter, att inte
                ladda upp material du inte har rätt till, och att inte använda tjänsten för något
                annat än rekrytering och utbildning.
            </p>
        </LegalSection>

        <LegalSection heading="4. Innehåll du laddar upp">
            <p>
                Vem som äger CV, ansökningar, kursmaterial och annat innehåll, och vilken rätt
                Nexilink har att visa det för de arbetsgivare du söker jobb hos.
            </p>
        </LegalSection>

        <LegalSection heading="5. Personuppgifter">
            <p>
                Hur vi behandlar personuppgifter beskrivs i{' '}
                <a href="/integritetspolicy" className="text-[#1A4D4F] font-medium hover:underline">
                    integritetspolicyn
                </a>
                .
            </p>
        </LegalSection>

        <LegalSection heading="6. Avsluta ditt konto">
            <p>
                Du kan när som helst radera ditt konto under Kontoinställningar. All din data raderas
                permanent och kan inte återställas. Här beskrivs eventuella undantag — exempelvis
                uppgifter som måste sparas enligt lag.
            </p>
        </LegalSection>

        <LegalSection heading="7. Ansvar och ändringar">
            <p>
                Ansvarsbegränsning, tillgänglighet till tjänsten, hur ändringar av villkoren
                meddelas, samt vilken lag som gäller och var tvister avgörs.
            </p>
        </LegalSection>

        <LegalSection heading="8. Kontakt">
            <p>Kontaktuppgifter till den som ansvarar för tjänsten.</p>
        </LegalSection>
    </LegalPage>
);

export default TermsPage;
